module.exports = __webpack_public_path__ + "static/media/stickermule.476f4b47.png";